import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import RtnRcptIndexActions, { RtnRcptIndexTypes } from '../Stores/RtnRcptIndex/Actions';

const getAppStore = state => state.app;

export function* rtnRcptIndexFetchRtnRcptIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(RtnRcptIndexActions.rtnRcptIndexFetchRtnRcptIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `rtnRcpt/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        RtnRcptIndexActions.rtnRcptIndexFetchRtnRcptIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(RtnRcptIndexActions.rtnRcptIndexFetchRtnRcptIndexLoading(false));
  }
}

export function* rtnRcptIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/rtnRcptDetail/update/${hdrId}`));
}

export function* rtnRcptIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/RTN_RCPT/${hdrId}/RtnRcptHdr`));
}

export function* rtnRcptIndexResetRtnRcptSync01({ hdrIds }) {
  try {
    yield put(RtnRcptIndexActions.rtnRcptIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `rtnRcpt/syncProcess/RESET_RTN_RCPT_SYNC_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(RtnRcptIndexActions.rtnRcptIndexResetRtnRcptSync01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(RtnRcptIndexActions.rtnRcptIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(RtnRcptIndexTypes.RTN_RCPT_INDEX_FETCH_RTN_RCPT_INDEX, rtnRcptIndexFetchRtnRcptIndex),
  takeLatest(RtnRcptIndexTypes.RTN_RCPT_INDEX_GO_TO_DOCUMENT, rtnRcptIndexGoToDocument),
  takeLatest(RtnRcptIndexTypes.RTN_RCPT_INDEX_GO_TO_AUDIT, rtnRcptIndexGoToAudit),
  takeLatest(RtnRcptIndexTypes.RTN_RCPT_INDEX_RESET_RTN_RCPT_SYNC01, rtnRcptIndexResetRtnRcptSync01)
];
